import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { getAllInsurances } from "../../queries";
import { InsuranceRead } from "../../../types";

export function useAllInsurances() {
  const {
    data,
    error,
    isLoading: loading,
    refetch,
  } = useQuery<AxiosResponse<InsuranceRead[]>>({
    queryKey: ["insurances"],
    queryFn: getAllInsurances,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
  });

  return {
    data: data?.data ?? [],
    total: data?.data?.length ?? 0,
    loading,
    error,
    refetch,
  };
}
